export const MENU_CLICKED = "MENU_CLICKED"
export const HIDE_BUTTON = "HIDE_BUTTON"